import React from "react";
import { GitCompare, X } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function CompareFloatingBar() {
  const { compareList, openCompare, clearCompare, compareOpen, COMPARE_MAX } = useApp();

  if (compareOpen || compareList.length === 0) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 bg-[#1B1B1B] text-white shadow-2xl flex items-center gap-4 pl-5 pr-2 py-2 border border-[#2C4C3B]"
      data-testid="compare-floating-bar"
    >
      <GitCompare size={18} className="text-[#C85A32]" />
      <div className="text-sm">
        <span className="font-medium" data-testid="compare-bar-count">
          {compareList.length}
        </span>
        <span className="text-white/60"> / {COMPARE_MAX} to compare</span>
      </div>
      <button
        onClick={openCompare}
        data-testid="compare-bar-open"
        className="bg-[#C85A32] hover:bg-[#b04a24] text-white text-xs uppercase tracking-[0.16em] px-4 py-2 font-medium transition-colors"
      >
        Compare
      </button>
      <button
        onClick={clearCompare}
        aria-label="Clear all"
        data-testid="compare-bar-clear"
        className="text-white/60 hover:text-white w-8 h-8 flex items-center justify-center"
      >
        <X size={16} />
      </button>
    </div>
  );
}
